export default "__VITE_ASSET__DrLkUGX___"